"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var layout_exports = {};
__export(layout_exports, {
  bpmnMetrics: () => import_geometry2.bpmnMetrics,
  layoutBpmn: () => layoutBpmn,
  wrapFlowLabel: () => wrapFlowLabel,
  wrapLabel: () => wrapLabel
});
module.exports = __toCommonJS(layout_exports);
var import_geometry = require("./geometry");
var import_labels = require("./labels");
var import_geometry2 = require("./geometry");
function shapeMetrics(element) {
  switch (element.kind) {
    case "startEvent":
    case "endEvent":
    case "intermediateEvent":
      return { width: 40, height: 40, labelPlacement: "below" };
    case "gateway":
      return { width: 48, height: 48, labelPlacement: "below" };
    case "subProcess":
      return { width: 176, height: 76, labelPlacement: "inside" };
    default:
      return { width: 152, height: 64, labelPlacement: "inside" };
  }
}
__name(shapeMetrics, "shapeMetrics");
function wrapLabel(text, maxWidth) {
  const maxChars = Math.max(4, Math.floor(maxWidth / import_geometry.bpmnMetrics.charWidth));
  const words = text.trim().split(/\s+/).filter((w) => w.length > 0);
  if (words.length === 0) return [];
  const lines = [];
  let current = "";
  for (const word of words) {
    if (current.length === 0) {
      current = word;
    } else if (current.length + 1 + word.length <= maxChars) {
      current = `${current} ${word}`;
    } else {
      lines.push(current);
      current = word;
    }
  }
  if (current.length > 0) lines.push(current);
  return lines;
}
__name(wrapLabel, "wrapLabel");
function narrowestFlowLabel(words) {
  const { maxFlowLabelWords } = import_geometry.bpmnMetrics;
  const perLine = words.length <= 2 ? 1 : Math.min(maxFlowLabelWords, Math.max(2, Math.ceil(words.length / maxFlowLabelWords)));
  const lines = [];
  for (let index = 0; index < words.length; index += perLine) {
    lines.push(words.slice(index, index + perLine).join(" "));
  }
  return lines;
}
__name(narrowestFlowLabel, "narrowestFlowLabel");
function wrapFlowLabel(text, maxWidth) {
  const words = text.trim().split(/\s+/).filter((w) => w.length > 0);
  if (words.length === 0) return [];
  const narrowest = narrowestFlowLabel(words);
  if (maxWidth === void 0) return narrowest;
  for (let count = 1; count < narrowest.length; count++) {
    const lines = (0, import_geometry.splitIntoLines)(words, count);
    if ((0, import_geometry.textBlockWidth)(lines) <= maxWidth) return lines;
  }
  return narrowest;
}
__name(wrapFlowLabel, "wrapFlowLabel");
function rankElements(diagram) {
  const ranks = /* @__PURE__ */ new Map();
  const indegree = /* @__PURE__ */ new Map();
  const outgoing = /* @__PURE__ */ new Map();
  const incoming = /* @__PURE__ */ new Map();
  for (const element of diagram.elements) {
    indegree.set(element.id, 0);
    outgoing.set(element.id, []);
    incoming.set(element.id, []);
  }
  for (const flow of diagram.flows) {
    if (flow.from === flow.to) continue;
    outgoing.get(flow.from)?.push(flow.to);
    incoming.get(flow.to)?.push(flow.from);
    indegree.set(flow.to, (indegree.get(flow.to) ?? 0) + 1);
  }
  const queue = diagram.elements.filter((e) => (indegree.get(e.id) ?? 0) === 0).map((e) => e.id);
  const placed = new Set(queue);
  for (const id of queue) ranks.set(id, 0);
  const visit = /* @__PURE__ */ __name((id) => {
    const rank = ranks.get(id) ?? 0;
    for (const next of outgoing.get(id) ?? []) {
      const left = (indegree.get(next) ?? 0) - 1;
      indegree.set(next, left);
      if (placed.has(next)) continue;
      ranks.set(next, Math.max(ranks.get(next) ?? 0, rank + 1));
      if (left === 0) {
        placed.add(next);
        queue.push(next);
      }
    }
  }, "visit");
  for (let head = 0; head < queue.length; head++) {
    visit(queue[head]);
  }
  for (const element of diagram.elements) {
    if (placed.has(element.id)) continue;
    const rank = (incoming.get(element.id) ?? []).filter((id) => placed.has(id)).reduce((max, id) => Math.max(max, (ranks.get(id) ?? 0) + 1), 0);
    ranks.set(element.id, rank);
    placed.add(element.id);
    const head = queue.length;
    queue.push(element.id);
    for (let i = head; i < queue.length; i++) {
      visit(queue[i]);
    }
  }
  return ranks;
}
__name(rankElements, "rankElements");
function sizeElement(element, column) {
  const { lineHeight, labelGap, shapeLabelPadding } = import_geometry.bpmnMetrics;
  const base = shapeMetrics(element);
  const inside = base.labelPlacement === "inside";
  const wrapWidth = inside ? base.width - 2 * shapeLabelPadding : Math.max(base.width + 48, 104);
  const labelLines = wrapLabel(element.label, wrapWidth);
  const labelWidth = (0, import_geometry.textBlockWidth)(labelLines);
  const labelHeight = labelLines.length * lineHeight;
  const metrics = inside ? {
    ...base,
    width: Math.max(base.width, labelWidth + 2 * shapeLabelPadding),
    height: Math.max(base.height, labelHeight + 2 * shapeLabelPadding)
  } : base;
  return {
    element,
    metrics,
    labelLines,
    footprint: Math.max(metrics.width, inside ? 0 : labelWidth),
    totalHeight: metrics.height + (inside ? 0 : labelHeight + labelGap),
    column
  };
}
__name(sizeElement, "sizeElement");
function layoutBpmn(diagram) {
  const {
    padding,
    titleHeight,
    columnGap,
    rowGap,
    fontSize,
    lineHeight,
    labelGap,
    flowLabelPadding,
    maxFlowLabelWidth,
    loopLaneGap,
    selfLoopOffset,
    poolHeaderWidth,
    laneHeaderWidth,
    lanePadding,
    minLaneHeight,
    poolGap,
    minPoolWidth
  } = import_geometry.bpmnMetrics;
  if (diagram.elements.length === 0 && diagram.pools.length === 0) {
    return { title: diagram.title, width: 0, height: 0, shapes: [], edges: [], pools: [], lanes: [], messageEdges: [] };
  }
  const pooled = diagram.pools.length > 0;
  const ranks = rankElements(diagram);
  const byRank = [];
  for (const element of diagram.elements) {
    const rank = ranks.get(element.id) ?? 0;
    while (byRank.length <= rank) byRank.push([]);
    byRank[rank].push(element);
  }
  const columns = byRank.filter((column) => column.length > 0);
  const sized = /* @__PURE__ */ new Map();
  columns.forEach((column, index) => {
    for (const element of column) {
      sized.set(element.id, sizeElement(element, index));
    }
  });
  const columnWidths = columns.map(
    (column) => column.reduce((max, element) => Math.max(max, sized.get(element.id)?.footprint ?? 0), 0)
  );
  const bands = [];
  const bandByOwner = /* @__PURE__ */ new Map();
  const bandsByPool = /* @__PURE__ */ new Map();
  const addBand = /* @__PURE__ */ __name((pool, lane) => {
    const band = {
      pool,
      lane,
      columns: columns.map(() => []),
      y: 0,
      innerHeight: 0,
      height: 0,
      loops: 0,
      routed: 0,
      labelRise: 0
    };
    bands.push(band);
    if (pool !== void 0) {
      const existing = bandsByPool.get(pool);
      if (existing === void 0) bandsByPool.set(pool, [band]);
      else existing.push(band);
    }
    return band;
  }, "addBand");
  for (const pool of diagram.pools) {
    const poolLanes = diagram.lanes.filter((lane) => lane.pool === pool.id);
    if (poolLanes.length === 0 || diagram.elements.some((e) => e.owner === pool.id)) {
      bandByOwner.set(pool.id, addBand(pool.id));
    }
    for (const lane of poolLanes) {
      bandByOwner.set(lane.id, addBand(pool.id, lane.id));
    }
  }
  let free;
  const bandOf = /* @__PURE__ */ __name((id) => {
    const owner = sized.get(id)?.element.owner;
    const band = owner !== void 0 ? bandByOwner.get(owner) : void 0;
    return band ?? free;
  }, "bandOf");
  if (!pooled || diagram.elements.some((e) => e.owner === void 0 || !bandByOwner.has(e.owner))) {
    free = addBand();
    bands.unshift(bands.pop());
  }
  for (const element of diagram.elements) {
    const item = sized.get(element.id);
    const band = bandOf(element.id);
    if (item === void 0 || band === void 0) continue;
    band.columns[item.column].push(item);
  }
  const stackHeight = /* @__PURE__ */ __name((items) => items.reduce((sum, item) => sum + item.totalHeight, 0) + rowGap * Math.max(0, items.length - 1), "stackHeight");
  const centerOffsets = /* @__PURE__ */ new Map();
  for (const band of bands) {
    for (const column of band.columns) {
      let top = -stackHeight(column) / 2;
      for (const item of column) {
        centerOffsets.set(item.element.id, top + item.metrics.height / 2);
        top += item.totalHeight + rowGap;
      }
    }
  }
  const sameRow = /* @__PURE__ */ __name((from, to) => {
    const source = bandOf(from);
    if (source === void 0 || source !== bandOf(to)) return false;
    return Math.abs((centerOffsets.get(from) ?? 0) - (centerOffsets.get(to) ?? 0)) < 0.5;
  }, "sameRow");
  const fanOfGateway = /* @__PURE__ */ new Map();
  for (const flow of diagram.flows) {
    const from = sized.get(flow.from);
    const to = sized.get(flow.to);
    if (from === void 0 || to === void 0) continue;
    if (from.element.kind !== "gateway" || to.column <= from.column) continue;
    if ((flow.label?.trim() ?? "").length === 0) continue;
    const branches = fanOfGateway.get(flow.from);
    if (branches === void 0) fanOfGateway.set(flow.from, [flow]);
    else branches.push(flow);
  }
  const namedAtTarget = /* @__PURE__ */ new Set();
  for (const branches of fanOfGateway.values()) {
    if (branches.length < 2) continue;
    for (const flow of branches) {
      if (!sameRow(flow.from, flow.to)) namedAtTarget.add(flow);
    }
  }
  const flowLabelLines = /* @__PURE__ */ new Map();
  const flowElbowRun = /* @__PURE__ */ new Map();
  const columnGaps = columns.map(() => columnGap);
  const elbowRun = columnGap / 2;
  const flowLabelRoom = /* @__PURE__ */ new Map();
  const straightRoom = columns.map(() => 0);
  for (const flow of diagram.flows) {
    const from = sized.get(flow.from);
    const to = sized.get(flow.to);
    if (from === void 0 || to === void 0) continue;
    const label = flow.label?.trim() ?? "";
    if (label.length === 0) continue;
    if (to.column <= from.column) {
      const lines2 = wrapFlowLabel(label, maxFlowLabelWidth);
      if (lines2.length > 0) flowLabelLines.set(flow, lines2);
      continue;
    }
    const straight = sameRow(flow.from, flow.to);
    const room = (straight ? columnGap : columnGap - elbowRun) - 2 * flowLabelPadding;
    const lines = wrapFlowLabel(label, room);
    if (lines.length === 0) continue;
    flowLabelLines.set(flow, lines);
    const needed = (0, import_geometry.textBlockWidth)(lines) + 2 * flowLabelPadding;
    flowLabelRoom.set(flow, needed);
    if (straight) straightRoom[from.column] = Math.max(straightRoom[from.column], needed);
    const over = namedAtTarget.has(flow) ? to : from;
    const rise = labelGap + (lines.length - 1) * lineHeight + fontSize - over.metrics.height / 2;
    const band = bandOf(over.element.id);
    if (band !== void 0) band.labelRise = Math.max(band.labelRise, rise);
  }
  for (const [flow, needed] of flowLabelRoom) {
    const from = sized.get(flow.from);
    if (from === void 0) continue;
    if (sameRow(flow.from, flow.to)) {
      columnGaps[from.column] = Math.max(columnGaps[from.column], needed);
      continue;
    }
    if (namedAtTarget.has(flow)) {
      const run2 = Math.max(elbowRun, straightRoom[from.column]);
      columnGaps[from.column] = Math.max(columnGaps[from.column], run2 + needed);
      continue;
    }
    const run = Math.max(needed, straightRoom[from.column]);
    flowElbowRun.set(flow, run);
    columnGaps[from.column] = Math.max(columnGaps[from.column], run + elbowRun);
  }
  if (pooled) {
    for (const flow of diagram.flows) {
      if ((ranks.get(flow.to) ?? 0) > (ranks.get(flow.from) ?? 0)) continue;
      const band = bandOf(flow.from);
      if (band !== void 0) band.loops++;
    }
  }
  for (const band of bands) {
    const content = band.columns.reduce((max, column) => Math.max(max, stackHeight(column)), 0);
    const margin = Math.max(band.pool === void 0 ? 0 : lanePadding, band.labelRise);
    band.innerHeight = band.pool === void 0 ? content + 2 * margin : Math.max(minLaneHeight, content + 2 * margin);
    band.height = band.innerHeight + (band.loops > 0 ? band.loops * loopLaneGap + 10 : 0);
  }
  const contentTop = padding + (diagram.title !== void 0 ? titleHeight : 0);
  const anyLanes = diagram.lanes.length > 0;
  const contentLeft = pooled ? padding + poolHeaderWidth + (anyLanes ? laneHeaderWidth : 0) + lanePadding : padding;
  const columnX = [];
  let nextX = contentLeft;
  for (let c = 0; c < columns.length; c++) {
    columnX.push(nextX);
    nextX += columnWidths[c] + (c < columns.length - 1 ? columnGaps[c] : 0);
  }
  const contentRight = columns.length > 0 ? nextX : contentLeft + minPoolWidth;
  const frameRight = pooled ? contentRight + lanePadding : contentRight;
  const width = frameRight + padding;
  const poolFrames = [];
  const laneFrames = [];
  let y = contentTop;
  if (free !== void 0) {
    free.y = y;
    y += free.height + (pooled ? poolGap : 0);
  }
  for (const pool of diagram.pools) {
    const poolBands = bandsByPool.get(pool.id) ?? [];
    const top = y;
    for (const band of poolBands) {
      band.y = y;
      y += band.height;
    }
    const height2 = Math.max(y - top, minLaneHeight);
    y = top + height2;
    poolFrames.push({
      id: pool.id,
      label: pool.label,
      x: padding,
      y: top,
      width: frameRight - padding,
      height: height2,
      headerWidth: poolHeaderWidth
    });
    poolBands.forEach((band, index) => {
      const lane = diagram.lanes.find((l) => l.id === band.lane);
      if (lane === void 0) return;
      laneFrames.push({
        id: lane.id,
        pool: lane.pool,
        label: lane.label,
        x: padding + poolHeaderWidth,
        y: band.y,
        width: frameRight - padding - poolHeaderWidth,
        height: band.height,
        headerWidth: laneHeaderWidth,
        separator: index > 0
      });
    });
    y += poolGap;
  }
  if (pooled) y -= poolGap;
  const contentBottom = y;
  const shapes = [];
  const shapeById = /* @__PURE__ */ new Map();
  for (const band of bands) {
    band.columns.forEach((column, index) => {
      let top = band.y + (band.innerHeight - stackHeight(column)) / 2;
      for (const item of column) {
        const shape = {
          id: item.element.id,
          kind: item.element.kind,
          gateway: item.element.gateway,
          x: columnX[index] + (columnWidths[index] - item.metrics.width) / 2,
          y: top,
          width: item.metrics.width,
          height: item.metrics.height,
          labelLines: item.labelLines,
          labelPlacement: item.metrics.labelPlacement
        };
        shapeById.set(shape.id, shape);
        top += item.totalHeight + rowGap;
      }
    });
  }
  for (const element of diagram.elements) {
    const shape = shapeById.get(element.id);
    if (shape !== void 0) shapes.push(shape);
  }
  const edges = [];
  let loopLanes = 0;
  for (const flow of diagram.flows) {
    const source = shapeById.get(flow.from);
    const target = shapeById.get(flow.to);
    if (source === void 0 || target === void 0) continue;
    const forward = target.x > source.x + source.width;
    if (forward) {
      const sx2 = source.x + source.width;
      const sy = source.y + source.height / 2;
      const tx2 = target.x;
      const ty = target.y + target.height / 2;
      const lines2 = flowLabelLines.get(flow);
      if (Math.abs(sy - ty) < 0.5) {
        const edge2 = {
          from: flow.from,
          to: flow.to,
          label: flow.label,
          points: [
            { x: sx2, y: sy },
            { x: tx2, y: ty }
          ],
          // Centered in the gap, which was widened until the label fits into it, and above
          // the line, so the text keeps clear of both shapes and of the arrow head.
          labelPosition: { x: (sx2 + tx2) / 2, y: sy - labelGap },
          labelAnchor: 0
        };
        if (lines2 !== void 0 && lines2.length > 1) edge2.labelLines = lines2;
        edges.push(edge2);
      } else {
        const terminal = namedAtTarget.has(flow) ? flowLabelRoom.get(flow) : void 0;
        const column = sized.get(flow.from)?.column ?? 0;
        const midX = terminal !== void 0 ? Math.max(columnX[column] + columnWidths[column] + elbowRun, tx2 - terminal) : sx2 + Math.max((tx2 - sx2) / 2, flowElbowRun.get(flow) ?? 0);
        const edge2 = {
          from: flow.from,
          to: flow.to,
          label: flow.label,
          points: [
            { x: sx2, y: sy },
            { x: midX, y: sy },
            { x: midX, y: ty },
            { x: tx2, y: ty }
          ],
          // Centered on the horizontal segment the label names, and above it, so the label
          // keeps a gap from the line and stays clear of the elbow: the run that leaves the
          // source, which starts at the first point, or, for a branch of a fan, the run that
          // ends at the target, which starts at the third one.
          labelPosition: terminal !== void 0 ? { x: (midX + tx2) / 2, y: ty - labelGap } : { x: (sx2 + midX) / 2, y: sy - labelGap },
          labelAnchor: terminal !== void 0 ? 2 : 0
        };
        if (lines2 !== void 0 && lines2.length > 1) edge2.labelLines = lines2;
        edges.push(edge2);
      }
      continue;
    }
    const band = bandOf(flow.from);
    let laneY;
    if (pooled && band !== void 0) {
      laneY = band.y + band.innerHeight + 10 + band.routed * loopLaneGap;
      band.routed++;
    } else {
      laneY = contentBottom + 20 + loopLanes * loopLaneGap;
      loopLanes++;
    }
    const selfLoop = flow.from === flow.to;
    const sx = source.x + source.width / 2 - (selfLoop ? selfLoopOffset : 0);
    const tx = target.x + target.width / 2 + (selfLoop ? selfLoopOffset : 0);
    const edge = {
      from: flow.from,
      to: flow.to,
      label: flow.label,
      points: [
        { x: sx, y: source.y + source.height },
        { x: sx, y: laneY },
        { x: tx, y: laneY },
        { x: tx, y: target.y + target.height }
      ],
      // Over the piece of line that runs back under the elements, which is the only one of
      // the four with room for a name.
      labelPosition: { x: (sx + tx) / 2, y: laneY - labelGap },
      labelAnchor: 1
    };
    const lines = flowLabelLines.get(flow);
    if (lines !== void 0 && lines.length > 1) edge.labelLines = lines;
    edges.push(edge);
  }
  const boxOf = /* @__PURE__ */ __name((id) => {
    const shape = shapeById.get(id);
    if (shape !== void 0) {
      return { x: shape.x, y: shape.y, width: shape.width, height: shape.height, pool: false };
    }
    const frame = poolFrames.find((p) => p.id === id);
    if (frame === void 0) return void 0;
    return {
      x: frame.x + frame.headerWidth,
      y: frame.y,
      width: frame.width - frame.headerWidth,
      height: frame.height,
      pool: true
    };
  }, "boxOf");
  const messageEdges = [];
  for (const flow of diagram.messageFlows) {
    const source = boxOf(flow.from);
    const target = boxOf(flow.to);
    if (source === void 0 || target === void 0) continue;
    const clamp = /* @__PURE__ */ __name((value, box) => Math.min(Math.max(value, box.x + lanePadding), box.x + box.width - lanePadding), "clamp");
    let sx = source.x + source.width / 2;
    let tx = target.x + target.width / 2;
    if (source.pool && !target.pool) sx = clamp(tx, source);
    else if (!source.pool && target.pool) tx = clamp(sx, target);
    const below = target.y >= source.y + source.height;
    const above = source.y >= target.y + target.height;
    const sy = below ? source.y + source.height : above ? source.y : source.y + source.height / 2;
    const ty = below ? target.y : above ? target.y + target.height : target.y + target.height / 2;
    const midY = (sy + ty) / 2;
    const straight = Math.abs(sx - tx) < 0.5;
    const edge = {
      from: flow.from,
      to: flow.to,
      label: flow.label,
      dashed: true,
      points: straight ? [
        { x: sx, y: sy },
        { x: tx, y: ty }
      ] : [
        { x: sx, y: sy },
        { x: sx, y: midY },
        { x: tx, y: midY },
        { x: tx, y: ty }
      ],
      labelPosition: { x: (sx + tx) / 2, y: midY - labelGap },
      labelAnchor: straight ? 0 : 1
    };
    const lines = wrapFlowLabel(flow.label ?? "", maxFlowLabelWidth);
    if (lines.length > 1) edge.labelLines = lines;
    messageEdges.push(edge);
  }
  const loopsBottom = loopLanes > 0 ? contentBottom + 20 + (loopLanes - 1) * loopLaneGap : contentBottom;
  const height = loopsBottom + padding;
  const layout = {
    title: diagram.title,
    width,
    height,
    shapes,
    edges,
    pools: poolFrames,
    lanes: laneFrames,
    messageEdges
  };
  (0, import_labels.placeBpmnLabels)(layout);
  return layout;
}
__name(layoutBpmn, "layoutBpmn");
//# sourceMappingURL=layout.js.map
